import { Radio, Mail, AlertTriangle, Clock, CheckCircle2 } from "lucide-react";

export const PEPPOL_META = {
  delivered: { label: "Livrée", cls: "border-green-200 bg-green-50 text-green-700", Icon: CheckCircle2 },
  emailed: { label: "Échec → envoyée par email", cls: "border-amber-200 bg-amber-50 text-amber-800", Icon: Mail },
  failed: { label: "Échec", cls: "border-red-200 bg-red-50 text-red-700", Icon: AlertTriangle },
  rejected: { label: "Refusée", cls: "border-red-200 bg-red-50 text-red-700", Icon: AlertTriangle },
};
const PENDING = { label: "En attente", cls: "border-[#C9D4F4] bg-[#EEF1FC] text-[#3A5CC8]", Icon: Clock };

export const peppolMeta = (status) => PEPPOL_META[status] || PENDING;

export const PeppolBadge = ({ peppol, testId }) => {
  if (!peppol?.document_id) return null;
  const { label, cls, Icon } = peppolMeta(peppol.status);
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap ${cls}`}>
      <Radio className="w-3 h-3" /> Peppol · <Icon className="w-3 h-3" /> {label}
    </span>
  );
};

export const PeppolSummary = ({ items }) => {
  const sent = items.filter((i) => i.peppol?.document_id);
  if (!sent.length) return null;
  const count = (fn) => sent.filter(fn).length;
  const cards = [
    ["Transmises via Peppol", sent.length, "factures et notes de crédit", "border-[#E2E7F7] bg-white"],
    ["Livrées", count((i) => i.peppol.status === "delivered"), "reçues par le client", "border-[#E2E7F7] bg-white shadow-[inset_3px_0_0_#059669]"],
    ["En attente", count((i) => !["delivered", "emailed", "failed", "rejected"].includes(i.peppol.status)), "en cours de livraison", "border-[#E2E7F7] bg-white shadow-[inset_3px_0_0_#3A5CC8]"],
    ["Échecs", count((i) => ["failed", "rejected", "emailed"].includes(i.peppol.status)), "basculées par email automatiquement", "border-[#E2E7F7] bg-white shadow-[inset_3px_0_0_#F59E0B]"],
  ];
  return (
    <div data-testid="peppol-summary" className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-3">
      {cards.map(([label, value, hint, cls]) => (
        <div key={label} className={`rounded-xl border p-4 ${cls}`}>
          <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-[#5C6A87] inline-flex items-center gap-1.5"><Radio className="w-3 h-3" /> {label}</p>
          <p className="mt-1 font-mono text-xl font-bold tabular-nums text-[#0F2645]">{value}</p>
          <p className="text-xs text-[#5C6A87]">{hint}</p>
        </div>
      ))}
    </div>
  );
};
